module.exports = __webpack_public_path__ + "2ebfa45b3a7f56784f60ceb812b75eaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/x.png
// module id = 535
// module chunks = 0